import { Divider, Tooltip } from "antd"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { OXE_SYNC_URL } from "../../utils/Config"
import { setContentLoading, setUmcNotification } from "../../store/reducers/CommonReducer"
import { getTranslated } from "../../utils/CommonUtils"
import { getOxeSyncSchema, getOxeSyncData } from "../../store/actions/OxeActions"
import { getSessionItem } from "../../utils/storageUtils"
import { getDomains, checkIfAnyModified } from "../../utils/SchemaParseUtils"
import { InfoCircleFilled } from "@ant-design/icons"
import confirmModal from "../common/confirmModal"
import UMCButton from "../common/UMCButton"
import { setCurrentMergedData, setBaseMergeData, setValidateState } from "../../store/reducers/CommonReducer"
import UMCAttributeView from "../common/UMCAttributeView"
import { updateModelItem } from "../../store/actions/CommonActions"
import { CC_PRODUCT_ID } from "../../utils/Constants"
import {validateAllMandatoryAttr } from '../../utils/ValidationUtils'
import { sendGTMEvent } from "../../utils/GTMUtils"


const OxeConfig = ({ switchToTab }) => {

    const dispatch = useDispatch()
    const oxeSystemConfigSchema = useSelector(state => state.oxe.oxeSystemConfigSchema)
    const oxeSystemConfigData = useSelector(state => state.oxe.oxeSystemConfigData)
    const currentMergedData = useSelector(state => state.common.currentMergedData)
    const baseMergeData = useSelector(state => state.common.baseMergeData)
    const dict = useSelector(state => state.common.dict)
    const oxeAndClientInfo = useSelector(state => state.oxe.oxeAndClientInfo)

    const [meargedSchema, setMeargedSchema] = useState([])
    const [umcValue, setUmcValue] = useState(null)


    useEffect(() => {
        dispatch(setContentLoading(true))
        dispatch(getOxeSyncSchema())
        dispatch(getOxeSyncData())

        return (() => {
            dispatch(setCurrentMergedData(null))
            dispatch(setBaseMergeData(null))
        })

    }, [])

    useEffect(() => {
        if (oxeSystemConfigSchema.response?.length && oxeSystemConfigData.response?.length) {
            const mergedData = mergeSchemaWithData(oxeSystemConfigSchema, oxeSystemConfigData)
            setMeargedSchema(mergedData)
            dispatch(setCurrentMergedData(mergedData))
            dispatch(setBaseMergeData(mergedData))
            dispatch(setContentLoading(false))
        }

    }, [oxeSystemConfigSchema, oxeSystemConfigData])

    useEffect(() => {
        const umcAttribute = currentMergedData?.find(domain => domain.id === "umcparameter")?.attribute?.find(attr => attr.id === "discriminationByUMC")
        if (umcAttribute) {
            setUmcValue(umcAttribute.value)
        }
    }, [currentMergedData])

    const generalSection = meargedSchema.find((item) => item.id === "general")
    const umcParams = meargedSchema.find((item) => item.id === "umcparameter")

    // Extract attributes
    const leftAttributes = generalSection?.subdomain?.find((sub) => sub.id === "generalleft")?.attribute || []
    const rightAttributes = generalSection?.subdomain?.find((sub) => sub.id === "generalright")?.attribute || []
    const groupAttributes = generalSection?.subdomain?.find((sub) => sub.groupattribute)?.groupattribute || []
    const umcAttribute = umcParams?.attribute?.find((attr) => attr.id === "discriminationByUMC")



    const getInfoIcon = (props) => {
        return <>
            <Tooltip title={props}>
                <InfoCircleFilled className="radio-info-icon" role="icon" />
            </Tooltip>
        </>

    }

    const handleUmcParameterClick = () => {
        const newValue = !umcValue
        setUmcValue(newValue)

        const updatedData = currentMergedData.map(domain => {
            if (domain.id === "umcparameter") {
                return {
                    ...domain,
                    attribute: domain.attribute.map(attr =>
                        attr.id === "discriminationByUMC" ? { ...attr, value: newValue } : attr
                    ),
                }
            }
            return domain
        })
        dispatch(setCurrentMergedData(updatedData))
    }


    const mergeSchemaWithData = (schema, data) => {
        const domainSchema = getDomains(schema)
        const domainnData = getDomains(data)

        // Marging Attributes 
        const mergerAttribute = (schmeaAttribute, dataAttribute) => {
            return schmeaAttribute?.map(schemaAttr => {
                const matchingDataAttibute = dataAttribute?.find((dataAtt) => dataAtt.id === schemaAttr.id)
                if (matchingDataAttibute) {
                    return { ...schemaAttr, value: matchingDataAttibute.value }
                }
                return schemaAttr
            })
        }


        // marging Group Attribute 
        const mergeGroupAttribute = (groupSchemaAttribute, groupDataAttribute) => {
            return groupSchemaAttribute?.map(groupSchemaAtt => {
                const matchingGroupDataAttribute = groupDataAttribute.find(groupDataAtt => groupDataAtt.id === groupSchemaAtt.id)
                if (matchingGroupDataAttribute) {
                    return {
                        ...groupSchemaAtt,
                        attribute: groupSchemaAtt.attribute?.map(attr1 => {
                            const matchingAttr = matchingGroupDataAttribute.attribute.find(attr2 => attr2.id === attr1.id)
                            return matchingAttr.value ? { ...attr1, value: matchingAttr.value } : attr1
                        })
                    }
                }
            })
        }

        // merging subdomains
        const mergeSubdomains = (schemaSubdomains, dataSubdomains) => {
            return schemaSubdomains?.map((schemaSubdomain) => {
                const matchingDataSubdomain = dataSubdomains?.find(
                    (dataSubdomain) => dataSubdomain.id === schemaSubdomain.id
                )
                return {
                    ...schemaSubdomain,
                    attribute: mergerAttribute(schemaSubdomain.attribute, matchingDataSubdomain?.attribute || []),
                    groupattribute: mergeGroupAttribute(
                        schemaSubdomain.groupattribute || [],
                        matchingDataSubdomain?.groupattribute || []
                    ),
                }
            })
        }


        // Merging domains
        const mergedDomains = domainSchema.map((schemaDomain) => {
            const matchingDataDomain = domainnData.find((dataDomain) => dataDomain.id === schemaDomain.id)

            return {
                ...schemaDomain,
                subdomain: mergeSubdomains(schemaDomain.subdomain, matchingDataDomain?.subdomain || []),
                attribute: mergerAttribute(schemaDomain.attribute, matchingDataDomain?.attribute || []),
            }
        })

        return mergedDomains

    }

    return (
        <div className="oxe-info-tab">
            <Divider orientation="left" orientationMargin="0" plain>{oxeAndClientInfo.clientName || getSessionItem(CC_PRODUCT_ID)}</Divider>
            <div className="att-flex" >
                <div className="attr-block" style={{ marginRight: "120px" }}>
                    <div>
                        {
                            leftAttributes.map(att => {
                                return <div className="attr-block" >
                                    <span className="attr-label">{getTranslated(dict, att.label)}</span>
                                    <div className="oxe-att-wrapper">
                                        <span style={{ flex: 1 }}>  <UMCAttributeView attribute={att} /></span>
                                        {getInfoIcon(getTranslated(dict, att?.help))}
                                    </div>
                                </div>
                            })
                        }
                    </div>
                    <>
                        {
                            groupAttributes.map(group =>
                                <div className="attr-block">
                                    <span className="att-label">{getTranslated(dict, group?.label)}</span>
                                    <div style={{ display: "flex", flexDirection: "row" }} className="attr-block">
                                        {
                                            group?.attribute.map(att =>
                                            (<>
                                                <div style={{ display: "flex", flexDirection: "row", marginLeft: "10px", justifyContent: "space-between" }}>
                                                    <div className="att-label" style={{ display: "flex", marginRight: "10px", alignItems:"center" }}><b>{getTranslated(dict, att.label)}</b></div>
                                                    <UMCAttributeView attribute={att} />
                                                </div>
                                            </>
                                            )
                                            )
                                        }
                                        {getInfoIcon(getTranslated(dict, group?.help))}
                                    </div>
                                </div>
                            )
                        }

                    </>
                </div>
                <div className="attr-block" style={{ marginRight: "120px" }}>
                    {
                        rightAttributes.map(att => {
                            return (att.widget == "TEXTFIELD") ? (
                                <div className="attr-block" >
                                    <span className="att-label">{getTranslated(dict, att?.label)}</span>
                                    <div className="oxe-att-wrapper">
                                        <span style={{ flex: 1 }}>  <UMCAttributeView attribute={att} /></span>
                                        {getInfoIcon(getTranslated(dict, att?.help))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="attr-block" >
                                        {(att.widget != "CHECKBOX") ?
                                            <>
                                                <span className="att-value">{getTranslated(dict, att.label)}</span>
                                                <span style={{ flex: 1 }}> <UMCAttributeView attribute={att} /></span>

                                            </>
                                            :
                                            <div className="oxe-att-wrapper">
                                                <span style={{ flex: 1 }}> <UMCAttributeView attribute={att} /></span>
                                            </div>
                                        }


                                    </div>
                                </>
                            )
                        })
                    }
                </div>
            </div>


            {/* <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, "LABEL_UMC_PARAMETERS")}</Divider>
            <div className="attr-block" >
                <span className="attr-label"> {getTranslated(dict, umcAttribute?.label)} :</span>
                <span className="attr-value">{getTranslated(dict, umcAttribute?.value)} </span>
                {getInfoIcon(getTranslated(dict, umcAttribute?.help))}
                <UMCButton label={getTranslated(dict, umcAttribute?.buttonaddon?.label)} type="primary" className="cont-header-btn" ></UMCButton>
            </div> */}


            <div className="oxe-sync-footer">
                <UMCButton
                    label={getTranslated(dict, "LABEL_BACK")}
                    type="default"
                    title={getTranslated(dict, "LABEL_BACK")}
                    className="secondary-back-btn cont-header-btn footer-back-btn"
                    disabled={JSON.stringify(currentMergedData) === JSON.stringify(baseMergeData)}
                    onClick={() => {
                        try {
                            const hasUnsaved = checkIfAnyModified(currentMergedData)
                            if (hasUnsaved) {
                                confirmModal({
                                    title: "MSG_LEAVE_PAGE",
                                    content: "MSG_LOSE_CONFIG",
                                    onOk: () => {
                                        dispatch(getOxeSyncData())
                                        if (switchToTab) switchToTab("OXE_information")
                                    }
                                })
                                return
                            }
                        } catch (e) {
                            // fallback: just navigate
                        }

                        dispatch(setCurrentMergedData(null))
                        dispatch(setBaseMergeData(null))
                        if (switchToTab) switchToTab("OXE_information")
                    }}
                />
                <UMCButton label={getTranslated(dict, "LABEL_SAVE")} type="primary" title={getTranslated(dict, "LABEL_SAVE")} className="cont-header-btn"
                    disabled={JSON.stringify(currentMergedData) === JSON.stringify(baseMergeData)}
                    onClick={() => {
                        const validateStatus = validateAllMandatoryAttr(currentMergedData, baseMergeData)
                        if (validateStatus) {
                            dispatch(setValidateState(false))
                            dispatch(setContentLoading(true))
                            dispatch(updateModelItem(`${OXE_SYNC_URL}/systemconf/${getSessionItem(CC_PRODUCT_ID)}`,
                                (isSuccess) => {
                                    // Send GTM event for OXE parameter save action
                                    sendGTMEvent({
                                        event: "umc_system_configuration",
                                        action: "Save in OXE parameter"
                                    })

                                    if (isSuccess) {
                                        dispatch(setUmcNotification({
                                            type: "success",
                                            message: getTranslated(dict, "LABEL_SAVED"),
                                            description: ""
                                        }))
                                        dispatch(getOxeSyncData())
                                        dispatch(setContentLoading(false))
                                    } else {
                                        dispatch(setUmcNotification({
                                            type: "success",
                                            message: getTranslated(dict, "LABEL_FAILED"),
                                            description: ""
                                        }))
                                        dispatch(setContentLoading(false))

                                    }
                                }
                            ))
                        } else {
                            dispatch(setValidateState(true))
                        }
                    }}></UMCButton>
            </div>

        </div>


        // </div>
    )


}



export default OxeConfig
